import { Link } from 'components/common/Link';
import { UiIcon, UiText } from 'znanie-uikit';

import css from './LinkTo.module.scss';

interface IProps {
  text?: string;
  direction?: 'forward' | 'backward';
  href: string;

  onClick?(): void;
}

export default function LinkTo({
  direction = 'forward',
  text = 'Смотреть все',
  href,
  onClick = () => {},
}: IProps) {
  return (
    <div className={css.link}>
      <Link href={href} onClick={onClick}>
        <UiText className={css.text} size="small_plus">
          {direction === 'backward' && (
            <span className={css.backIcon}>
              <UiIcon name="back" size={12} />
            </span>
          )}
          {text}
          {direction === 'forward' && (
            <span className={css.forwardIcon}>
              <UiIcon name="forward" size={12} />
            </span>
          )}
        </UiText>
      </Link>
    </div>
  );
}
